export const SHOW_PROMO_BANNER_EVENT = 'show-promo-banner'

export const showFloatingPromoBanner = () => {
  window.dispatchEvent(new Event(SHOW_PROMO_BANNER_EVENT))
}

export const showFloatingPromoBannerFromClickable = (event) => {
  const target = event?.target

  if (!target?.closest) return

  const clickable = target.closest(
    'button, a, [role="button"], [data-promo-clickable="true"]'
  )

  if (!clickable || event.currentTarget?.contains?.(clickable) === false) return

  showFloatingPromoBanner()
}
